import 'globals';

(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
	    const body = $('body');
        const toTopButton = ['<a title="Zum Seitenanfang" href="#top" class="scroll-btn to-top"><i class="ai ai-chevron-up"></i></a>'].join("");
        const toBottomButton = ['<a title="Zum Seitenende" href="#bottom" class="scroll-btn to-bottom"><i class="ai ai-chevron-down"></i></a>'].join("");

        body.append(toTopButton);
        body.append(toBottomButton);

        $('.scroll-btn').hide();
        $(body).removeClass('scroll-to-top-show');
        $(function () {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    $('.scroll-btn').fadeIn();
                    $(body).addClass('scroll-to-top-show');
                } else {
                    $('.scroll-btn').fadeOut();
                    $(body).removeClass('scroll-to-top-show');
                }
            });

            $('.back-to-top').click(function () {
                $('body,html').animate({scrollTop: 0}, 800);
                return false;
            });
        });
    });
})(jQuery, window, document, window.PageLoadedQueue);
